export enum EModeMesure {
    Telemetre = 1,
    EstimationVisuelle = 2,
    Decametre = 3,
    TelemetreDecametre = 4
}